module.exports = __webpack_public_path__ + "static/img/img-home-co-02.5c7cf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-02.png
// module id = lmSi
// module chunks = 1